export const formatWithOffset = (value: string): string => {
  if (!value) {
    return value;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  const pad = (n: number) => n.toString().padStart(2, '0');
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absoluteOffsetMinutes = Math.abs(offsetMinutes);
  const offsetHours = Math.floor(absoluteOffsetMinutes / 60);
  const offsetMins = absoluteOffsetMinutes % 60;

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}${sign}${pad(offsetHours)}:${pad(offsetMins)}`;
};

export const normalizeActivityDates = <
  T extends { startDate: string; endDate: string },
>(
  activity?: T | null
): T | null | undefined => {
  if (!activity) {
    return activity;
  }

  return {
    ...activity,
    startDate: formatWithOffset(activity.startDate),
    endDate: formatWithOffset(activity.endDate),
  };
};
